import { ToastrService } from 'ngx-toastr';
import {
  CurriculaVMModel,
  CurriculumProductLevel,
  CurriculumProductLevelPrice,
  PaymentProviderRequestResult,
  SelectedCurriculumModel,
  StudentModel,
  GetDemoRedirectModel,
  ConsumerCurriculumJargon,
  StudentConsumerCurriculum,
} from '../../../Elearning-Models';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IServiceFactory } from '../../../Services/service-factory';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { environment } from 'src/environments/environment';
import { SimplePopupDialogComponent } from 'src/app/simple-popup-dialog/simple-popup-dialog.component';
import { CurriculumRegisterParentPasswordComponent } from './curriculum-register-parent-password/curriculum-register-parent-password.component';
@Component({
  selector: 'app-curriculum-register',
  templateUrl: './curriculum-register.component.html',
  styleUrls: ['./curriculum-register.component.scss'],
})
export class CurriculumRegisterComponent implements OnInit {
  
  public dataService: CurriculumService;
  public curriculumData: CurriculaVMModel;
  public curriculumDataReceived: boolean = false;
  public curriculumID: any;
  public studentList: StudentModel[];
  public registerForm: FormGroup;
  public selectedStudent: StudentModel;
  public selectedStudentData: StudentModel;
  public selectedCurriculumData: SelectedCurriculumModel;
  
  public hasNoRecord: boolean = false;
  public hasDemoUnfinished: boolean = false;
  public hasDemoFinished: boolean = false;
  public hasPaidRecord: boolean = false;
  public existingStudentConsumerCurriculum: StudentConsumerCurriculum
  


  public selectedCurriculumProductLevelID: number = null; // grab this from activated route
  public selectedStudentID: number;
  ParentPassword: string = null;
  isTeacher: boolean;

  isNewcomer: boolean;
  assignCurrWait: boolean = false;
  

  imagePath = environment.imagePath + 'assets/images/curriculumImages/';
  
  jargon: ConsumerCurriculumJargon;
  
  constructor(
    public dialog: MatDialog,
    private serviceFactory: IServiceFactory,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router
    ) {
      this.dataService = this.serviceFactory.getCurriculumService();
    }
    
    
    ngOnInit(): void {
      
      this.jargon = this.dataService.jargon;
      
      this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
        this.curriculumID = params.get('id');
        var productLevelFromRoute = +params.get('productLevelID');
        
        this.selectedCurriculumProductLevelID = productLevelFromRoute;
        
        this.selectedStudentID = +params.get('studentID');


        this.dataService.CheckIsNewComer().subscribe(result => {
          this.isNewcomer = result;
          this.GetData();
        });
      });
    }

  

  private GetData() {
    this.GetMatchingStudentCurriculumRecord(this.selectedStudentID, this.curriculumID);
    this.getCurriculumData();
    this.setIsTeacher();
    this.selectedStudent = null;

    this.registerForm = this.formBuilder.group({
      curriculumID: [this.curriculumID],
      student: [undefined, [Validators.required]],
    });

    this.getStudentList();
  }

  
    
    clearAllRecordVariables(){
      this.hasNoRecord = false;
      this.hasPaidRecord = false;
      this.hasDemoFinished = false;
      this.hasDemoUnfinished = false;
      this.existingStudentConsumerCurriculum = null;
    }
    
    setHasNoRecord(){
      this.clearAllRecordVariables();
      this.hasNoRecord = true;
    }
    
    setHasDemoUnfinished(record: StudentConsumerCurriculum){
      this.clearAllRecordVariables();
      this.hasDemoUnfinished = true;
      this.existingStudentConsumerCurriculum = record;
    }
    
    setHasDemoFinished(record: StudentConsumerCurriculum){
      this.clearAllRecordVariables();
      this.hasDemoFinished = true;
      this.existingStudentConsumerCurriculum = record;    
    }

    setIsTeacher() {
      this.isTeacher = false;

      this.dataService.GetIsTeacher().subscribe((result) => {
        if (result){
          this.isTeacher = true;
          return;
        } else {
          this.isTeacher = false;
          return;
        }
      });
    }
    
    setHasPaidRecord(record: StudentConsumerCurriculum){
      this.clearAllRecordVariables();
      this.hasPaidRecord = true;
      this.existingStudentConsumerCurriculum = record;
    } 
    
    viewDiagResults(){
      this.router.navigate([environment.rootPath + 'CurriculumDiagnosticFeatures/' + this.existingStudentConsumerCurriculum.ID]);
    }
    
    navigateExistingCurriculum(){
      this.router.navigate([environment.rootPath + 'CurriculumView/' + this.existingStudentConsumerCurriculum.HBClassID]);
    }
    
    /**
     * This method is called on change of student selection.
     */
    changeStudentSelection = (data): void => {        
        var studentID = data.StudentID        
        
        this.GetMatchingStudentCurriculumRecord(studentID,this.curriculumID);
        this.selectedStudentID = studentID;

        if (this.isNewcomer){
          this.selectedCurriculumProductLevelID = 0;  
        }
      };
      
      
      GetMatchingStudentCurriculumRecord(StudentID: number, curriculumID: number) {
        if(StudentID == -1 || StudentID == 0){
          this.clearAllRecordVariables();
          return;
        }
        this.dataService.GetStudentConsumerCurriculum(StudentID, curriculumID).subscribe((result) => {
          if (!result){
            this.setHasNoRecord();
          } else if (!!result.PurchaseDate){
            this.setHasPaidRecord(result)
            return;
          } else if (result.HasDemoCompleted) {
            this.setHasDemoFinished(result);
          } else {
            this.setHasDemoUnfinished(result);
          }
        });
      }
      
      /**
       * This method is used to open dialog popup.
       */
      openRegisterDialog = () => {
        const dialogRef = this.dialog.open(RegisterDialogComponent, {
          data: {
            curriculumID: this.curriculumID,
            title: 'Register Student',
          },
        });
        
        const sub = dialogRef.componentInstance.valueUpdated.subscribe(
          (assignment) => {
            if (!assignment) {
              this.selectedStudent = null;
              this.clearAllRecordVariables();
              return;
            }
            this.selectedStudentData = null;
            let selectedStudentData = {
              StudentID: assignment.StudentID,
              StudentFirstName: assignment.StudentFirstName,
              StudentLastName: assignment.StudentLastName,
            };
            this.studentList.push(selectedStudentData);
            this.setHasNoRecord();
            this.selectedStudentData = assignment;
            this.selectedStudent = selectedStudentData;
            this.selectedStudentID = assignment.StudentID;
          }
          );
          
    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  };
  
  /**
   * This method is used to get list of Students.
   */
  getStudentList = (): void => {
    this.dataService.GetStudentList().subscribe((response: any) => {
      this.studentList = [];
      this.studentList = response;
      this.selectedStudent = this.studentList?.find(s => s.StudentID == this.selectedStudentID);
      this.curriculumDataReceived = true;

      if(this.studentList.length == 0){
        this.openRegisterDialog();
      }
    });
  };

  
  
  
  
  getParentPassword() {
    const dialogRef = this.dialog.open(CurriculumRegisterParentPasswordComponent, {
      data: {
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (validated) => {
        if(validated){
          this.ParentPassword = validated;
          this.makeAssignCurriculumPayment();
        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }


  makeAssignCurriculumPayment() {
    this.assignCurrWait = true;
    const params = {
      CurriculumID: this.curriculumID ? this.curriculumID : null,
      StudentID: this.selectedStudent && this.selectedStudent.StudentID ? this.selectedStudent.StudentID : null,
      CurriculumProductLevelID: this.selectedCurriculumProductLevelID,
      Password: this.ParentPassword
    };
    this.dataService.AssignCurriculum(params).subscribe((res: PaymentProviderRequestResult) => {
      if (res.Success) {
        this.toastr.success('Curriculum Assigned.', 'Success!');
        this.selectedStudent = null;
        window.location.href = res.RequestUrl;
      } else {
        //if success = false and requestURL != null then they already have paid for it, so reroute them to curr view page.
        if(res.RequestUrl != null){
          window.location.href = res.RequestUrl;
        } 
        else{
          this.toastr.error(res.ResultMessage, 'Failure!');
        }
      }
      this.assignCurrWait = false;
    });
  }
  
  /**
   * This method is used to assign curriculum.
   */
  AssignCurriculum = (): void => {
    if (this.selectedStudent.StudentID <= 0) {
      this.toastr.warning('Please select student', 'Warning!');
      return;
    }
    
    if (!this.selectedCurriculumProductLevelID){
      this.toastr.warning('Please a product level', 'Warning!');
      return;
    }

    if(this.assignCurrWait){
      return;
    }
    
    if (!this.isTeacher){
      this.getParentPassword();
    } else {
      this.makeAssignCurriculumPayment();
    }   
  };

  /**
   * This method is used to get selected Curriculum Data.
   */
  getCurriculumData = (): void => {
    this.dataService
      .GetSelectedCurriculum(this.curriculumID)
      .subscribe((res) => {
        if (res) {
          this.selectedCurriculumData = res;
        }
      });
  };

  setSelectedProductLevel(productlevel: CurriculumProductLevelPrice){
    this.selectedCurriculumProductLevelID = productlevel.ICurriculumProductLevel.ID;
  }


  //// TAKE DEMO BUTTON CLICK
  onButtonClickTakeDemo(){
    if (this.selectedStudent.StudentID <= 0) {
      this.toastr.warning('Please select student', 'Warning!');
      return;
    }

    if(this.assignCurrWait){
      return;
    }

    const dialogRef = this.dialog.open(SimplePopupDialogComponent, {
      data: {
        okString: "Ok",
        title: "Login",
        cancelString: "Cancel",
        dialog: "This will log you in as " + this.selectedStudent.StudentFirstName + " " + this.selectedStudent.StudentLastName +" to start taking the free diagnostic exam. Do you want to proceed?"
      },
    });

    const sub = dialogRef.componentInstance.valueUpdated.subscribe(
      (yes) => {
        if(yes){
          this.onTakeDemo();          
        }
      });

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });

  }

  onTakeDemo(){
    this.assignCurrWait = true;
    // send in model: currID, studentID, currName
    var model = new GetDemoRedirectModel();
    model.CurriculumID = this.selectedCurriculumData.CurriculumID;
    model.CurriculumName = this.selectedCurriculumData.CurriculumName;
    model.StudentID = this.selectedStudent.StudentID;
    // on subscribe:
    // reroute to either:
    //  a. curr view listing if they paid already
    //  b. results page for the demo if they took the demo already
    //  c. continue demo page if they are still taking it
    //  d. take them to demo
    this.dataService.GetDemoRedirect(model).subscribe(result => {
      if(!!result && result.Success){
        
        window.location.reload(); 
        window.location.href = result.URL;
      }
      else{
        this.toastr.warning('Could not process this request at this time.', 'Warning!');
        this.assignCurrWait = false;
      }
    });
  }

  addNewStudent(){
    this.openRegisterDialog();
  }

}
